import { render, staticRenderFns } from "./StatIcon.vue?vue&type=template&id=bb8b6a10&scoped=true"
import script from "./StatIcon.vue?vue&type=script&lang=js"
export * from "./StatIcon.vue?vue&type=script&lang=js"
import style0 from "./StatIcon.vue?vue&type=style&index=0&id=bb8b6a10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8b6a10",
  null
  
)

export default component.exports